// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "./TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "./CrossIcon.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";
import * as PilotRadioButtonMultiChoice$LiteracyplanetTupperware from "../v3/PilotRadioButtonMultiChoice.res.mjs";
import * as SkilfulMultiChoiceSingleResponseContainer$LiteracyplanetTupperware from "./SkilfulMultiChoiceSingleResponseContainer.res.mjs";

function SkilfulRadioButtonMultiChoice$Radio(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.Radio.className
            }, React.createElement("div", {
                  className: "SkilfulRadioButtonMultiChoice-RadioSelection"
                }));
}

var Radio = {
  make: SkilfulRadioButtonMultiChoice$Radio
};

function SkilfulRadioButtonMultiChoice$Skilful(props) {
  return React.createElement(SkilfulMultiChoiceSingleResponseContainer$LiteracyplanetTupperware.make, {
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: React.createElement("div", {
                    className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.className
                  }, React.createElement(SkilfulRadioButtonMultiChoice$Radio, {}), props.children, React.createElement("div", undefined, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                            className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.CorrectMarkIcon.className
                          }), React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                            className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.IncorrectMarkIcon.className
                          })))
            });
}

var Skilful = {
  make: SkilfulRadioButtonMultiChoice$Skilful
};

function SkilfulRadioButtonMultiChoice(props) {
  var children = props.children;
  var __group = props.group;
  var responseOptionId = props.responseOptionId;
  var questionIndex = props.questionIndex;
  var group = __group !== undefined ? Caml_option.valFromOption(__group) : "SingleResponse";
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(PilotRadioButtonMultiChoice$LiteracyplanetTupperware.make, {
                questionIndex: questionIndex,
                responseOptionId: responseOptionId,
                group: Caml_option.some(group),
                children: children
              });
  } else {
    return React.createElement(SkilfulRadioButtonMultiChoice$Skilful, {
                questionIndex: questionIndex,
                responseOptionId: responseOptionId,
                children: children
              });
  }
}

var make = SkilfulRadioButtonMultiChoice;

var $$default = SkilfulRadioButtonMultiChoice;

export {
  Radio ,
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
